<template>
  <div class="content">
    <h2 class="m-n">売上管理</h2>
    <div class="row m-t-md">

      <div v-if="checkSettingChatWork">
        <no-chat-work></no-chat-work>
      </div>
      <div v-if="checkSettingNoDanboard">
        <no-danboard></no-danboard>
      </div>

      <div>
        <div class="col-xs-4 col-sm-4 pd-l-0 p-hpanel-w" >
          <div class="hpanel">
            <div class="panel-body" v-bind:style="checkPaymentCount ? 'height: 310px' : 'height: 300px'">
              <div>
                <br>
                <div class="text-left">累計売上(税込)</div>
                <br>
                <div class="text-center font-bold">
                  <h1 v-bind:class="{ 'text-red': isMinus(saleAmount) }">{{ formatSaleAmount }}</h1>
                </div>
                <div class="text-center">
                  <p>{{ transactionDetails }}</p>
                  <p>{{ amountDetails }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-3 col-sm-3 pd-l-0 p-hpanel-w" >
          <div class="hpanel">
            <div class="panel-body" v-bind:style="checkPaymentCount ? 'height: 310px' : 'height: 300px'">
              <div>
                <br>
                <div class="text-left">未出金残高(税込)</div>
                <br>
                <div class="text-center font-bold">
                  <h1 v-bind:class="{ 'text-red': isMinus(unPaymentAmount) }">{{ formatUnPaymentAmount }}</h1>
                </div>
                <div class="text-left">
                  <p>※銀行口座が未入力または、誤っている場合はお振込みされません。<br><a href="/setting/payment-info">振込先の設定</a></p>
                  <p>※支払いサイクルの変更や1万円以下の場合でも出金したい場合は<a href="/setting/payment-cycle">こちら</a>より変更をお願いします。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-5 col-sm-5 pd-l-0 pd-r-0 p-hpanel-w">
          <div class="hpanel">
            <div class="panel-body" v-bind:style="checkPaymentCount ? 'height: 310px' : 'height: 300px'">
              <div>
                <br>
                <div class="text-left">直近出金予定</div>
                <br>
                <template v-if="displayStatus === 'none' || displayStatus === ''">
                  <div class="row flexbox">
                    <div class="text-left">
                      <h2>振込なし</h2>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <template v-for="(item, index) in payments">
                    <div :key="'row_' + index" class="row flexbox">
                      <div :key="'payment_at_' + index" class="col-xs-3 col-sm-3 text-center">
                        <span>{{ `${formatPaymentDate(item.paymentAt)}` }}</span>
                      </div>
                      <div :key="'amount_' + index" class="col-xs-4 col-sm-4 text-center">
                        <h1>{{ formatAmount(item.amount) }}</h1>
                      </div>
                      <div :key="'bank_' + index" class="col-xs-2 col-sm-2 text-center">
                        <span>{{ `(${item.bankName})` }}</span>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row hpanel">
          <ul class="nav nav-tabs">
            <li class="active disabled-tab" id="tab1Link" @click.prevent="changeTab('saleslist')">
              <a data-toggle="tab" href="#saleslist" aria-expanded="true">売上一覧</a>
            </li>
            <li id="tab2Link" class @click.prevent="changeTab('history')">
              <a data-toggle="tab" href="#history" aria-expanded="false">出金履歴</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="saleslist">
              <div class="panel-body">
                <base-table-client
                  :url="'Sale'"
                  :paginationStorageKey="'revenueSale'"
                  :columns="$options.salesColumns"
                >
                  <template slot="amount" slot-scope="props">
                    <b v-bind:class="{ 'text-red': isMinus(props.rowData.amount) }">{{ formatAmount(props.rowData.amount) }}</b>
                  </template>
                  <template slot="transactions" slot-scope="props">
                    <span>{{ props.rowData.transactions }} 件</span>
                  </template>
                  <template slot="action" slot-scope="props">
                    <button class="btn btn-warning" @click="csvDownload(props.rowData.salesMonth)">ダウンロード</button>
                  </template>
                </base-table-client>
              </div>
            </div>
            <div class="tab-pane" id="history">
              <div class="panel-body">
                <base-table-api
                  :url="'Payment2'"
                  :paginationStorageKey="'revenuePayment'"
                  :columns="$options.paymentColumns"
                >
                  <template slot="paymentAt" slot-scope="props">
                    <b>{{ formatPaymentDate(props.rowData.paymentAt) }}</b>
                  </template>
                  <template slot="paymentStatusCode" slot-scope="props">
                    <span>{{ paymentStatus(props.rowData.paymentStatusCode) }}</span>
                  </template>
                  <template slot="paymentAmount" slot-scope="props">
                    <span>{{ formatAmount(props.rowData.paymentAmount) }}</span>
                  </template>
                  <template slot="paymentSummary" slot-scope="props">
                    <span>{{ props.rowData.paymentSummary }}</span>
                  </template>

                  <template slot="action" slot-scope="props">
                    <div v-if="(props.rowData.salesStartAt && props.rowData.salesEndAt)">
                      <button class="btn btn-warning" @click="paymentPdfDownload(props.rowData.paymentId, props.rowData.paymentAt)">ダウンロード</button>
                    </div>
                  </template>
                </base-table-api>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import BaseTableClient from '@/components/BaseTableClient'
import BaseTableApi from '@/components/BaseTableAPI'
import NoDanboard from '@/components/NoDanboard'
import NoChatWork from '@/components/NoChatWork'
import Util from '@/common/utility'
import SettingService from '@/services/settingservice'
import SaleService from '@/services/saleservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTableClient,
    BaseTableApi,
    NoDanboard,
    NoChatWork
  },
  salesColumns: [
    {
      title: '売上月',
      name: 'salesMonth',
      cellClass: 'text-center',
      headerClass: 'col-md-2'
    },
    {
      title: '金額(税込)',
      name: 'amount',
      customCell: true,
      detailAmountCell: true,
      cellClass: 'text-right',
      headerClass: 'col-md-7'
    },
    {
      title: '取引件数',
      name: 'transactions',
      customCell: true,
      detailTransactionCell: true,
      cellClass: 'text-right',
      headerClass: 'col-md-4'
    },
    {
      title: '売上レポート',
      name: 'action',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-sm-2',
      sortable: false
    }
  ],
  paymentColumns: [
    {
      title: '日付',
      name: 'paymentAt',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-md-2'
    },
    {
      title: '結果',
      name: 'paymentStatusCode',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-md-1'
    },
    {
      title: '金額(税込)',
      name: 'paymentAmount',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-md-2'
    },
    {
      title: '摘要',
      name: 'paymentSummary',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-md-4'
    },
    {
      title: '支払明細書',
      name: 'action',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-md-3',
      sortable: false
    }
  ],
  data () {
    return {
      column: null,
      sort: null,
      saleAmount: null,
      displayStatus: '',
      payments: null,
      paymentsCount: 0,
      disableReqMoney: true,
      apiDone: [],
      loader: null,
      amountDetails: null,
      transactionDetails: null,
      unPaymentAmount: null,
      labels: { name: { title: 'First name' } },
      json_data: []
    }
  },
  created () {
    this.loader = this.$loading.show()
    this.getPaymentAmount()
    this.getSaleAmount()
    this.getSellerInfo()
    this.getUnPaymentAmount()
  },
  mounted () {
    this.$events.listen('done', (url) => {
      if (!this.apiDone.includes(url)) {
        this.apiDone.push(url)
      }
    })

    let logParams = {
      name: eventCode.manage_revenue.list_revenue_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
    paymentAmount () {
      this.disableReqMoney = (this.paymentAmount <= 0)
    },
    apiDone (newVal) {
      if (newVal.length === 2 && this.loader) {
        this.loader.hide()
      }
    }
  },
  computed: {
    formatSaleAmount () {
      return this.formatAmount(this.saleAmount)
    },
    formatPaymentAmount () {
      return this.formatAmount(this.paymentAmount)
    },
    formatUnPaymentAmount () {
      return this.formatAmount(this.unPaymentAmount)
    },
    checkSettingChatWork () {
      return this.$store.getters.getUser.chatWorkFlg !== '2'
    },
    checkSettingNoDanboard () {
      return this.$store.getters.getUser.danboardFlg !== '2'
    },
    checkPaymentCount () {
      return this.paymentsCount >= 3
    }
  },
  methods: {
    isMinus (value) {
      return value < 0
    },
    /*
     * Call API get payment amount
     *
     * @return void
     */
    getPaymentAmount () {
      SaleService.getPaymentAmount()
        .then((response) => {
          this.displayStatus = response.displayStatus
          this.payments = response.payments
          this.paymentsCount = response.payments.length
        })
    },
    /*
     * Call API get sale amount
     *
     * @return void
     */
    getSaleAmount () {
      SaleService.getSaleAmount()
        .then((response) => {
          this.saleAmount = response.amount
          this.amountDetails = response.amountDetails
          this.transactionDetails = response.transactionDetails
        })
    },
    getUnPaymentAmount () {
      SaleService.getUnPaymentAmount()
        .then((response) => {
          this.unPaymentAmount = response.un_payment_amount
        })
    },
    getSellerInfo () {
      SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
        .catch(err => {
          this.error = err
        })
    },
    redirectReqMoney () {
      if (!this.disableReqMoney) {
        this.$router.push('/reqmoney')
      }
    },
    /*
     * Format money
     *
     * @param {Int} value Value to be transformed
     *
     * @return {String}
     */
    formatAmount (value) {
      return value === null ? '' : `¥${Util.formatMoney(value)}`
    },
    paymentStatus (status) {
      return status === '2' ? '完了' : '予定'
    },
    /*
     * Format date
     *
     * @param {String} value Value to be transformed
     *
     * @return {String}
     */
    formatPaymentDate (value) {
      return moment(value).format('YYYY/MM/DD')
    },

    async csvDownload (salesMonth) {
      const payload = {
        record: {
          salesMonth: salesMonth + '/1'
        }
      }
      let logParams = {
        name: eventCode.manage_revenue.list_revenue_tab.click_download_button,
        properties: {
          salesMonth: payload.record.salesMonth
        }
      }
      EventService.postTrackLog(logParams)
      await SaleService.postRequestSaleDetailsDownload(payload, salesMonth + '.csv')
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    },
    async paymentPdfDownload (paymentId, paymentAt) {
      let logParams = {
        name: eventCode.manage_revenue.history_payment_tab.click_download_button,
        properties: {
          paymentAt: paymentAt
        }
      }
      EventService.postTrackLog(logParams)
      const params = {
        paymentId: paymentId
      }
      await SaleService.postRequestPaymentPdfDownload(params, this.formatPaymentDate(paymentAt) + '.pdf')
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    },
    changeTab (tab) {
      let logParamName = eventCode.manage_revenue.history_payment_tab.show
      $('#tab1Link').removeClass('disabled-tab')
      $('#tab2Link').addClass('disabled-tab')
      if (tab === 'saleslist') {
        $('#tab1Link').addClass('disabled-tab')
        $('#tab2Link').removeClass('disabled-tab')
        logParamName = eventCode.manage_revenue.list_revenue_tab.show
      }
      let logParams = {
        name: logParamName,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
@media (max-width: 1024px) {
  .col-sm-4 {
    width: 33.33333333% !important;
  }
  .col-sm-3 {
    width: 33.33333333% !important;
  }
  .col-sm-5 {
    width: 33.33333333% !important;
  }
}
@media (max-width: 425px) {
  .p-hpanel-w {
    width: 100% !important;
    padding-right: 0px !important;
  }
  .tab-pane /deep/ .table-wrapper {
    overflow-x: auto !important;
  }
  .tab-pane /deep/ .table-wrapper .table {
    min-width: 700px !important;
    max-width: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/revenue/Revenue.vue